import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        courseVersion: '=',
        course: '=',
        canManageCourse: '='
    },
    template: `
        <form-wrapper form="vm.form">
            <form ng-submit="vm.save()">
                <div class="well type02">
                    <courses-courses-steps-version-version
                        context="vm.context"
                        form="vm.form"
                        course-version="vm.courseVersion"
                        can-manage-course="vm.canManageCourse"
                        training-types="vm.trainingTypes"
                    />
                </div>
                <ul class="actions01">
                    <li>
                        <a ng-if="vm.canManageCourse && !vm.courseVersion.isArchived && !vm.course.isArchived" ng-click="vm.archive()" class="btn">
                            <span>{{ 'general.Archive' | translate }}</span>
                        </a>
                    </li>
                    <li>
                        <a ng-if="vm.canManageCourse && !vm.course.isArchived" ng-click="vm.save()" class="btn main">
                            <span>{{ 'general.Save' | translate }}</span>
                        </a>
                    </li>
                    <li>
                        <a ui-sref="authorized.courses.courses.edit.version.list()" class="btn discrete" >
                            <span>{{ 'general.Back to list' | translate }}</span>
                        </a>
                    </li>
                </ul>
                <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
            </form>
        </form-wrapper>
    `
})

export default class {
    constructor ($q, $translate, $scope, $state, CourseVersionService, ModalService,
                 CourseVersionResource, OccurrenceResource, FormFactory,
                 COURSE_TRAINING_TYPE_ENUM, OCCURRENCE_STATUS_ENUM, COURSE_PROGRESS_STATUS_TYPE_ENUM) {
        this.$q = $q;
        this.$translate = $translate;
        this.$scope = $scope;
        this.$state = $state;
        this.CourseVersionResource = CourseVersionResource;
        this.CourseVersionService = CourseVersionService;
        this.OccurrenceResource = OccurrenceResource;
        this.ModalService = ModalService;
        this.FormFactory = FormFactory;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.OCCURRENCE_STATUS_ENUM = OCCURRENCE_STATUS_ENUM;
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;
    }

    $onInit () {
        this.context = 'edit';
        this.CourseVersionService.nestCompositeModels(this.courseVersion);
        this.form = this.FormFactory.createFromResource(this.courseVersion, {
            expand: 'courseTrainings,courseTrainings.scorm,courseTrainings.courseTrainingI18ns,courseOccurrences,creator,updater,courseTrainingForms,courseVersionLicences,automatedPlanningGroups'
        });
        this.courseVersionCopy = angular.copy(this.courseVersion);
        this.trainingTypes = this.COURSE_TRAINING_TYPE_ENUM.KEYS;
        this.messages = [];
    }

    beforeSave () {
        this.CourseVersionService.mapTrainingForms(this.form.model.courseTrainings);
    }

    save () {
        this.beforeSave();
        // if checkbox is checked then confirm choice before save
        if (!this.courseVersionCopy.isWithoutPlanning && this.form.model.isWithoutPlanning) {
            const userCount = this.CourseVersionService.getWithoutPlanningUserCount(this.courseVersion);
            return this.ModalService.confirm(
                this.$translate.instant(
                    'version.Without planning confirm message', { count: userCount }
                ), 'medium')
                .then(() => this.form.save().then(
                    () => this.$state.go('authorized.courses.courses.edit.version.list', { id: this.form.model.courseId })
                ))
            ;
        }
        return this.form.save().then((updatedVersion) => {
            this.courseVersion = updatedVersion;
            this.CourseVersionService.nestCompositeModels(updatedVersion);
            this.form.model = updatedVersion;
            this.$scope.$emit('version:reload', updatedVersion);
        });
    }

    detectArchiveConfirmMessages () {
        const deferred = this.$q.defer();
        const detect = (resolve) => {
            if (!this.courseVersion.courseOccurrences.length) {
                this.messages.push(
                    this.$translate.instant('version.archive.general_confirm_message')
                );
                resolve();
            }
            else {
                const publishedOccurrences = this.courseVersion.courseOccurrences
                    .filter(occurrence => occurrence.status === this.OCCURRENCE_STATUS_ENUM.KEYS.PUBLISHED)
                ;
                if (publishedOccurrences.length) {
                    this.OccurrenceResource.getParticipants(
                        { pageSize: 0, privilegesCheck: 0 },
                        { occurrenceIds: publishedOccurrences.map(occurrence => occurrence.id) }
                    ).$promise.then((participants) => {
                        const notStartedParticipants = participants
                            .some(participant => participant.courseProgressStatus === this.COURSE_PROGRESS_STATUS_TYPE_ENUM.KEYS.NOT_STARTED)
                        ;
                        if (notStartedParticipants) {
                            this.messages.push(
                                this.$translate.instant('version.archive.not_started_participants_message')
                            );
                        }
                        else {
                            this.messages.push(
                                this.$translate.instant('version.archive.general_confirm_message')
                            );
                        }
                        resolve();
                    });
                }
                else {
                    const notPublishedOccurrenceCount = this.courseVersion.courseOccurrences.length - publishedOccurrences.length;
                    this.messages.push(
                        this.$translate.instant('version.archive.related_occurrences_message', { notPublishedOccurrenceCount })
                    );
                    resolve();
                }
            }
        };
        detect(deferred.resolve);
        return deferred.promise;
    }

    archive () {
        this.detectArchiveConfirmMessages().then(() => {
            const { messages, courseVersion, form } = this;
            return this.ModalService.open({
                template: `
                <modals-courses-version-archive
                    uib-modal-instance="vm.$uibModalInstance"
                    departments="vm.departments"
                    messages="vm.messages"
                    course-version="vm.courseVersion"
                    form="vm.form"
                />
                `,
                controller ($uibModalInstance, lodash) {
                    this.$uibModalInstance = $uibModalInstance;
                    this.messages = lodash.uniq(messages);
                    this.courseVersion = courseVersion;
                    this.form = form;
                }
            })
            .then(() => {})
            .catch(() => {});
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/version/edit/general/index.js